module.exports = __webpack_public_path__ + "img/Artboard – 6 (1).6a3bc165.png";